import { fetch } from '../../utils';
import Backend from '../../backend';

export const getInsurers = () => {
  return fetch(Backend.methodUrl('insurers'), {
    method: 'GET'
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};
